import { FC, ReactElement } from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';
import { useThrottle } from '@/common/hooks/useThrottle';

interface Props {
  id: string;
  children: ReactElement;
  onClick: () => void;
  className?: string;
}

export const CustomButton: FC<Props> = ({
  id,
  children,
  onClick,
  className,
}) => {
  const throttledClick = useThrottle(onClick);
  return (
    <button
      id={`${id}-button`}
      className={cn(styles.customButton, className)}
      onClick={throttledClick}
    >
      {children}
    </button>
  );
};
